import { Box, Modal } from "@mui/material";
import React, { useState } from "react";

import DeleteNote from "./DeleteNote";
import ViewNote from "./ViewNote";
import TypeNoteChip from "../Chips/TypeNoteChip";
import DateAndTimeChipMobile from "../Chips/DateAndTimeChipMobile";
import EditButtonMobile from "../Buttons/EditButtonMobile";
import DeleteButtoMobile from "../Buttons/DeleteButtoMobile";
import SmallClientChipMobile from "../SmallClientChipMobile";

import EditMedicalNoteMobile from "./EditMedicalNoteMobile";

function NotesContainerGlobalMedicalMobile(props) {
  //VARIABLES
  const styleLive = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    height: 600,
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleEdit = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleDeleteModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    height: 260,
    borderRadius: 2,
    bgcolor: "background.paper",
    /*border: "1px solid #000",*/
    boxShadow: 24,
    // p: 4,
  };

  //STATES
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);

  //FUNCTIONS
  const openEditModal = () => {
    setShowEditModal(true);
  };
  const openDeleteModal = () => {
    setShowDeleteModal(true);
  };
  const closeEditModal = () => {
    setShowEditModal(false);
  };
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
  };

  return (
    <div className="notes-wrapper">
      <Modal
        open={showEditModal}
        onClose={closeEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleEdit}>
          <EditMedicalNoteMobile
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeEditModal}
            fileLinks={props.fileUrls}
            relationshipFamilyNote={props.relationship}
          />
        </Box>
      </Modal>

      <Modal
        open={showDeleteModal}
        onClose={closeDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDeleteModal}>
          <DeleteNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeDeleteModal}
          />
        </Box>
      </Modal>

      <Modal
        open={showViewModal}
        onClose={closeViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleLive}>
          <ViewNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeViewModal}
          />
        </Box>
      </Modal>
      <div className="note-container-mobile">
        <div className="note-container-block-1-mobile">
          <DateAndTimeChipMobile date={props.noteDate} />
          <DateAndTimeChipMobile date={props.noteTime} />
          <TypeNoteChip noteType={props.noteType} />
        </div>

        <div className="note-container-block-3-mobile">
          <div className="note-container-line-0-mobile">
            <SmallClientChipMobile
              firstName={props.clientFirstName}
              lastName={props.clientLastName}
              avatar="1"
              clientPic={props.clientPic}
            />
          </div>
          <div className="note-container-line-1-mobile">
            <div className="note-container-line1-block1bis-mobile left-block">
              <div className="title-cell-container-mobile">
                <span className="title-text">Done by:</span>
                <span className="content-text">{props.doneBy}</span>
              </div>
            </div>

            <div className="note-container-line1-block2-mobile centre-block2">
              <div className="sub-block-2">
                <EditButtonMobile handleOpen={openEditModal} />
                <DeleteButtoMobile handleOpen={openDeleteModal} />
              </div>
            </div>
          </div>

          <div className="note-container-line-1-mobile-bis">
            {props.fileUrls && props.fileUrls.length > 0 ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <span className="note-container-line1-block1bis-mobile-fileattached1 left-block-mobile-1">
                  File(s) attached:{" "}
                </span>
                <span className="note-container-line1-block1bis-mobile-fileattached2">
                  {props.fileUrls
                    .map((file, index) => (
                      <a
                        href={file.url}
                        key={index}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {file.name}
                      </a>
                    ))
                    .reduce((prev, curr, index, array) => {
                      return index < array.length - 1
                        ? [prev, ", ", curr]
                        : [prev, curr];
                    }, [])}
                </span>
              </div>
            ) : (
              <div className="note-container-line-1-mobile-bis">
                No files attached
              </div>
            )}
          </div>

          <div
            className="note-container-line-2-mobile"
            style={{ whiteSpace: "pre-wrap" }}
          >
            {props.noteContent}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotesContainerGlobalMedicalMobile;
